var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:{
    'position-right': _vm.config.position == 'right',
    'position-left': _vm.config.position == 'left',
    'position-fixed': !_vm.display,
  }},[_c('div',{staticClass:"container",class:{
      'element-hide': !_vm.display,
      rtl: _vm.dir === 'rtl',
    }},[_c('router-view')],1),_c('div',{staticClass:"toggle",class:{
      'toggle-right': _vm.config.position == 'right',
      'toggle-left': _vm.config.position == 'left',
      'toggle-hide': _vm.display,
    },attrs:{"tabindex":"0"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.toggleDisplay.apply(null, arguments)},"click":_vm.toggleDisplay}},[_c('img',{attrs:{"src":require("@/assets/images/avatar-genio60.svg"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }